import React from 'react';

function AzioniRapide() {

    return (
        <div className="col-lg-12 mb_20">
            <div className="single_element">
                <div className="quick_activity">
                    <div className="row">
                        <div className="col-12">                            
                            <div className='row' style={{justifyContent: 'center'}}>
                                <div className="col-md-4 col-sm-8 col-xs-12 flex-container mb_30">
                                    <p>Qui puoi pubblicare un nuovo Annuncio, un nuovo Anniversario oppure un ringraziamento non correlato ad altri annunci.</p>  
                                    <a href="/nuovo-annuncio" className="btn btn-primary flex-item" title="Inserisci nuovo annuncio"><i className='ti-plus'></i>&nbsp; Annuncio primario o a sè stante</a>                                                                    
                                </div>
                                <div className="col-md-4 col-sm-8 col-xs-12 flex-container mb_30">
                                    <p>Usa questa funzionalità per pubblicare una nuova Partecipazione o un nuovo Ringraziamento, correlato ad un annuncio principale che hai già pubblicato.</p>
                                    <a href="/nuovo-allegato" className="btn btn-warning flex-item" title="Inserisci nuovo allegato"><i className='ti-plus'></i>&nbsp; Annuncio secondario o correlato</a>                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AzioniRapide;